import GoogleIcon from "@/assets/images/icons/g.svg?inline";
import { SOCIAL_AUTH } from "../../gql/AuthQueries";

export default {
  name: "google_auth",

  data() {
    return {
      gToken: "",
      submitGoogleLoading: false,
      agentLicense: "",
      firmName: ""
    };
  },

  mounted: function() {
    if (localStorage.getItem("signupAgentInfo")) {
      let signupAgentInfo = JSON.parse(localStorage.getItem("signupAgentInfo"));
      this.agentLicense = signupAgentInfo.licensse;
      this.firmName = signupAgentInfo.firmName;
    }
  },

  methods: {
    googleAuth() {
      this.submitGoogleLoading = true;

      this.$gAuth
        .signIn()
        .then(googleUser => {
          this.gToken = googleUser.getAuthResponse().access_token;
          this.loginRequest();
        })
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;

          for (let error in errors) {
            this.$toasted.error(errors[error].message);
          }
        })
        .finally(() => {
          this.submitGoogleLoading = false;
        });
    },

    loginRequest() {
      this.$apollo
        .mutate({
          mutation: SOCIAL_AUTH,
          variables: {
            provider: "google",
            accessToken: this.gToken,
            role: localStorage.getItem("signupAgentInfo") ? "agent" : "buyer",
            brokerName: this.firmName,
            licence: this.agentLicense,
            filters: (this.$store.state.filters && this.$store.state.filters.length) ? this.$store.state.filters.filter(filter => filter.filters) : [],
            propertyTypeId: parseInt(this.$store.state.propertyTypeId)
          }
        })
        .then(({ data: { socialAuth: { user, accessToken } } }) => {
          this.$store.dispatch("initUser", user);

          if (typeof localStorage !== "undefined" && accessToken) {
            localStorage.setItem("AUTH_TOKEN", accessToken);
            localStorage.removeItem("searchParams");
          }

          this.$toasted.success("You’ve been signed in");

          if (this.$route.name === "home_owners") return;

          if (user.role == "buyer") {
            if (user.firstName) {
              this.$router.push({
                name: "properties"
              });
            } else {
              this.$router.push({
                name: "personalize"
              });
            }
          } else {
            if (user.needUploadAgentDocuments) {
              this.$router.push({
                name: "identity_documents"
              });
            } else {
              this.$router.push({
                name: "home"
              });
            }
          }
        })
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;

          for (let error in errors) {
            this.$toasted.error(errors[error].message);
          }
        })
        .finally(() => {
          localStorage.removeItem("signupAgentInfo");
        });
    }
  },

  components: {
    GoogleIcon
  }
};
